import { httpClient } from "../../services/HttpClient";
import CustomField from "../models/CustomField";
import qs from "qs";

export class CustomFieldApi {

    private static getUrl(projectUuid: string, endpoint: string = ''): string {
        return `/projects/${projectUuid}/pim/custom-fields${endpoint}`;
    }

    static async findAll(projectUuid: string, request?: Record<string, any>): Promise<CustomField[]> {
        const response = await httpClient.get(this.getUrl(projectUuid), request)

        return response.data.data.map((item: any) => new CustomField(item));
    }

    static async create(projectUuid: string, request: Record<string, any>): Promise<CustomField> {
        const response = await httpClient.post(this.getUrl(projectUuid), request)

        return new CustomField(response.data.data)
    }

    static async edit(projectUuid: string, request: Record<string, any>, customFieldUuid: string): Promise<CustomField> {
        const response = await httpClient.patch(this.getUrl(projectUuid, `/${customFieldUuid}`), request)

        return new CustomField(response.data.data)
    }

    static async remove(projectUuid: string, customFieldUuid: string): Promise<void> {
        return await httpClient.delete(this.getUrl(projectUuid, `/${customFieldUuid}`))
    }

    static async import(projectUuid: string, importData: FormData): Promise<void> {
        return await httpClient.post(this.getUrl(projectUuid, "/import"), importData)
    }

    static async export(projectUuid: string, params: Record<string, any>): Promise<void> {
        window.open(this.getUrl(projectUuid, `/export?${qs.stringify(params)}`), '_blank')
    }
 }
